module.exports = __webpack_public_path__ + "static/404-cb6c9fe8acd8d66966472fa4c1c6e485.png";